// extracted by mini-css-extract-plugin
export default {"content":"AuditingError_content__dQlE+","errorIcon":"AuditingError_errorIcon__hwQiq"};